import getLocale from "./getLocale";
import generalConfig from "../config/generalConfig.js";

// Create the persistent Data Layer
export function createDataLayer(){
    window.digitalDataStore={
        page: {
            lastPage: ""
        },
        form: {
            'uniqueID': Date.now()
        },
        products:[],
        errors:[]        
    }
}

// Add product list to the permanent Data Layer
export function addProducts(products) {
    window.digitalDataStore.products=[];
    for(const product in products){
        let recommended=false;
        if(products[product].recommended===true){
           recommended = true;
        }
        window.digitalDataStore.products.push({
            'id':products[product].Product.ProductCode,
            'recommended': recommended
        });
    }   
}

// Handle a new page view event.
export function eventPageView(vue, step = ""){   
    const gc = generalConfig();

    // Create the persistent data layer if it hasnt been created yet.
    if(typeof(digitalDataStore) == 'undefined'){ 
        createDataLayer();
    }

    // Set Env
    let env;
    if(window.location.host==="radon-test.canadacentral.cloudapp.azure.com"||
    window.location.host==="cibc.internal.dev.local"){
        env = "development";
    } else {
        env = process.env.NODE_ENV
    }

    // Create/reset the temporary data layer
    window.digitalData = {
        events:{
            pageView: true,
            formStep: true
        },
        site: {
            'brand': "cibc",
            'name': "insurance",
            'type': "responsive",
            'environment': env,
            'appVersion': gc.appVersion,
            'lastBuildDate': gc.lastBuildDate
        },
        page: {
            'hierarchy': ["travel-insurance-application"],
            'accessibility': true
        },
        form: {
            name: 'travel-insurance-application',
            uniqueID: window.digitalDataStore.form.uniqueID
        }
    };
   
    // Fill in the data for this event

    window.digitalData.page.name="before-we-begin";
    if(step==="/TypeOfCoverage") { 
        window.digitalData.events.formQualify=true;
        window.digitalData.page.name="coverage-type";
    }
    else if(step==="/TravelPlans") { 
        window.digitalData.events.formView=true;
        window.digitalData.page.name="traveller-details";
    }
    else if(step==="/TravellerAges") { window.digitalData.page.name="traveller-age-details"}
    else if(step==="/Questionnaire1") { window.digitalData.page.name="eligibility"}
    else if(step==="/Questionnaire2") { window.digitalData.page.name="medical-history"}
    else if(step==="/Questionnaire3") { window.digitalData.page.name="medical-history-continued"}
    else if(step==="/Quote") { 
        window.digitalData.events.applicationProductRecommendations=true;
        window.digitalData.page.name="options";

        window.digitalData.products=window.digitalDataStore.products;
    }
    else if(step==="/Notices") {
        window.digitalDataStore.products;
        
        let recommended=false;
        if(vue.$store.state.product.recommended===true){
           recommended = true;
        }
        window.digitalDataStore.products=[{
            'id': vue.$store.state.product.Product.ProductCode,
            'recommended': recommended
        }];

        window.digitalData.page.name="terms-and-conditions";
        window.digitalData.products=window.digitalDataStore.products;
    }
    else if(step==="/ApplicantInfo") { 
        window.digitalData.page.name="application";
        window.digitalData.products=window.digitalDataStore.products;
    }
    else if(step==="/TravellerInfo") { 
        window.digitalData.page.name="traveller-info";
        window.digitalData.products=window.digitalDataStore.products;
    }
    else if(step==="/PaymentInfo") { 
        window.digitalData.page.name="payment-details";
        window.digitalData.products=window.digitalDataStore.products;
    }
    else if(step==="/Confirmation") { 
        window.digitalData.events.formSubmit=true;
        window.digitalData.page.name="thank-you";
        window.digitalData.products=window.digitalDataStore.products;

        let price = Number(vue.$store.state.product.Total);
        const res = String(vue.$store.state.product.Total).split(".");
        if(res.length === 1 || res[1].length < 3) {
          price = price.toFixed(2);
        }
        window.digitalData.transaction = {
            ID: vue.$store.state.transactionid,
            amount: price,
            serviceFee: 0
        }
    }
    else { // Before-we-begin
        window.digitalData.events.formQualify=true;
    }

    window.digitalData.form.stepName=window.digitalData.page.name;

    window.digitalData.page.url = window.location.href;

    if(window.digitalDataStore.page.lastPage===""){
        window.digitalData.page.referrer = document.referrer;
    } else {
        window.digitalData.page.referrer=window.digitalDataStore.page.lastPage;
    }
    
    window.digitalData.page.language = getLocale();

    // Clear errors from store
    window.digitalDataStore.errors=[];
    
    // Send a Direct Call Request to Adobe Analytics for them to process the event.
    if(typeof _satellite!== "undefined"){
        _satellite.track('track');
    }
}

// Handle an error event.
export function eventError(){
    // Create/reset the temporary data layer
    window.digitalData.events= {
            error: true
        };
    
    let verifiedErrors=[];
    // Loop through all the errors and remove any that have been resolved.
    for(const error in window.digitalDataStore.errors){
        if(window.digitalDataStore.errors[error].field==="API"||document.getElementById('err_'+window.digitalDataStore.errors[error].field).classList.contains('invalid-feedback')===true){
            verifiedErrors.push(window.digitalDataStore.errors[error])
        }
    }
    window.digitalDataStore.errors = verifiedErrors;
    
    // Fill in the data for this event
    window.digitalData.errors=window.digitalDataStore.errors;

    // Send a Direct Call Request to Adobe Analytics for them to process the event.
    if(typeof _satellite!== "undefined"){
        _satellite.track('track');
    }
}

export function addError(fieldid, code, type) {
    let alreadyPresent=false
    for(const error in window.digitalDataStore.errors){
        if(fieldid!==""&&window.digitalDataStore.errors[error].field===fieldid&&window.digitalDataStore.errors[error].type===type){
            alreadyPresent=true;
        }
    }
    if(alreadyPresent===false) {
        let index=0;
        if(window.digitalDataStore.errors.length>0){
            for(let error in window.digitalDataStore.errors){
                if(window.digitalDataStore.errors[error].index>=index){
                    index=window.digitalDataStore.errors[error].index+1;
                }
            }
        }
        window.digitalDataStore.errors.push({
            'index': index,
            'id':code,
            'field': fieldid,
            'type': type,
            'subtype': ''
        });
        // Don't send out individual error messages for form checks, just do one after.
        if(window.squelchErrors!==true){
            eventError();
        }
    }
}

export function setLastPage(){
    window.digitalDataStore.page.lastPage = document.URL;
}